/*! Kaltura Embed Code Generator - v1.2.0 - 2018-04-30
 * https://github.com/kaltura/EmbedCodeGenerator
 * Copyright (c) 2018 Ran Yefet; Licensed MIT */
(this.Handlebars = {}),
  (function (t) {
    (t.VERSION = '1.0.rc.2'),
      (t.helpers = {}),
      (t.partials = {}),
      (t.registerHelper = function (t, e, a) {
        a && (e.not = a), (this.helpers[t] = e);
      }),
      (t.registerPartial = function (t, e) {
        this.partials[t] = e;
      }),
      t.registerHelper('helperMissing', function (t) {
        if (2 === arguments.length) return void 0;
        throw Error("Could not find property '" + t + "'");
      });
    var e = Object.prototype.toString,
      a = '[object Function]';
    t.registerHelper('blockHelperMissing', function (r, n) {
      var l = n.inverse || function () {},
        i = n.fn,
        s = e.call(r);
      return (
        s === a && (r = r.call(this)),
        r === !0
          ? i(this)
          : r === !1 || null == r
          ? l(this)
          : '[object Array]' === s
          ? r.length > 0
            ? t.helpers.each(r, n)
            : l(this)
          : i(r)
      );
    }),
      (t.K = function () {}),
      (t.createFrame =
        Object.create ||
        function (e) {
          t.K.prototype = e;
          var a = new t.K();
          return (t.K.prototype = null), a;
        }),
      (t.logger = {
        DEBUG: 0,
        INFO: 1,
        WARN: 2,
        ERROR: 3,
        level: 3,
        methodMap: { 0: 'debug', 1: 'info', 2: 'warn', 3: 'error' },
        log: function (e, a) {
          if (e >= t.logger.level) {
            var r = t.logger.methodMap[e];
            'undefined' != typeof console && console[r] && console[r].call(console, a);
          }
        },
      }),
      (t.log = function (e, a) {
        t.logger.log(e, a);
      }),
      t.registerHelper('each', function (e, a) {
        var r,
          n = a.fn,
          l = a.inverse,
          i = 0,
          s = '';
        if ((a.data && (r = t.createFrame(a.data)), e && 'object' == typeof e))
          if (e instanceof Array) for (var o = e.length; o > i; i++) r && (r.index = i), (s += n(e[i], { data: r }));
          else for (var p in e) e.hasOwnProperty(p) && (r && (r.key = p), (s += n(e[p], { data: r })), i++);
        return 0 === i && (s = l(this)), s;
      }),
      t.registerHelper('if', function (r, n) {
        var l = e.call(r);
        return l === a && (r = r.call(this)), !r || t.Utils.isEmpty(r) ? n.inverse(this) : n.fn(this);
      }),
      t.registerHelper('unless', function (e, a) {
        var r = a.fn,
          n = a.inverse;
        return (a.fn = n), (a.inverse = r), t.helpers['if'].call(this, e, a);
      }),
      t.registerHelper('with', function (t, e) {
        return e.fn(t);
      }),
      t.registerHelper('log', function (e, a) {
        var r = a.data && null != a.data.level ? parseInt(a.data.level, 10) : 1;
        t.log(r, e);
      });
  })(this.Handlebars);
var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];
(Handlebars.Exception = function () {
  for (var t = Error.prototype.constructor.apply(this, arguments), e = 0; errorProps.length > e; e++)
    this[errorProps[e]] = t[errorProps[e]];
}),
  (Handlebars.Exception.prototype = Error()),
  (Handlebars.SafeString = function (t) {
    this.string = t;
  }),
  (Handlebars.SafeString.prototype.toString = function () {
    return '' + this.string;
  }),
  (function () {
    var t = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#x27;', '`': '&#x60;' },
      e = /[&<>"'`]/g,
      a = /[&<>"'`]/,
      r = function (e) {
        return t[e] || '&amp;';
      };
    Handlebars.Utils = {
      escapeExpression: function (t) {
        return t instanceof Handlebars.SafeString
          ? '' + t
          : null == t || t === !1
          ? ''
          : a.test(t)
          ? t.replace(e, r)
          : t;
      },
      isEmpty: function (t) {
        return t || 0 === t ? ('[object Array]' === Object.prototype.toString.call(t) && 0 === t.length ? !0 : !1) : !0;
      },
    };
  })(),
  (Handlebars.VM = {
    template: function (t) {
      var e = {
        escapeExpression: Handlebars.Utils.escapeExpression,
        invokePartial: Handlebars.VM.invokePartial,
        programs: [],
        program: function (t, e, a) {
          var r = this.programs[t];
          return a ? Handlebars.VM.program(e, a) : r ? r : (r = this.programs[t] = Handlebars.VM.program(e));
        },
        programWithDepth: Handlebars.VM.programWithDepth,
        noop: Handlebars.VM.noop,
      };
      return function (a, r) {
        return (r = r || {}), t.call(e, Handlebars, a, r.helpers, r.partials, r.data);
      };
    },
    programWithDepth: function (t, e) {
      var a = Array.prototype.slice.call(arguments, 2);
      return function (r, n) {
        return (n = n || {}), t.apply(this, [r, n.data || e].concat(a));
      };
    },
    program: function (t, e) {
      return function (a, r) {
        return (r = r || {}), t(a, r.data || e);
      };
    },
    noop: function () {
      return '';
    },
    invokePartial: function (t, e, a, r, n, l) {
      var i = { helpers: r, partials: n, data: l };
      if (void 0 === t) throw new Handlebars.Exception('The partial ' + e + ' could not be found');
      if (t instanceof Function) return t(a, i);
      if (Handlebars.compile) return (n[e] = Handlebars.compile(t, { data: void 0 !== l })), n[e](a, i);
      throw new Handlebars.Exception('The partial ' + e + ' could not be compiled when running in runtime-only mode');
    },
  }),
  (Handlebars.template = Handlebars.VM.template),
  (function (t, e) {
    var a = function (t, e) {
      var a = '',
        r = e ? e + '[' : '',
        n = e ? ']' : '';
      for (var l in t)
        if ('object' == typeof t[l])
          for (var i in t[l])
            a += '&' + r + encodeURIComponent(l) + '.' + encodeURIComponent(i) + n + '=' + encodeURIComponent(t[l][i]);
        else a += '&' + r + encodeURIComponent(l) + n + '=' + encodeURIComponent(t[l]);
      return a;
    };
    e.registerHelper('flashVarsUrl', function (t) {
      return a(t, 'flashvars');
    }),
      e.registerHelper('flashVarsString', function (t) {
        return a(t);
      }),
      e.registerHelper('elAttributes', function (t) {
        var e = '';
        for (var a in t) e += ' ' + a + '="' + t[a] + '"';
        return e;
      }),
      e.registerHelper('kalturaLinks', function () {
        if (!this.includeKalturaLinks) return '';
        var t = e.templates['templates/kaltura_links.hbs'];
        return t();
      }),
      e.registerHelper('seoMetadata', function () {
        var t = e.templates['templates/seo_metadata.hbs'];
        return t(this);
      });
  })(this, this.Handlebars),
  (this.Handlebars = this.Handlebars || {}),
  (this.Handlebars.templates = this.Handlebars.templates || {}),
  (this.Handlebars.templates['templates/auto.hbs'] = Handlebars.template(function (t, e, a, r, n) {
    function l(t, e) {
      var r,
        n,
        l,
        i = '';
      return (
        (i += '<div id="'),
        (r = a.playerId)
          ? (r = r.call(t, { hash: {}, data: e }))
          : ((r = t.playerId), (r = typeof r === d ? r.apply(t) : r)),
        (i += u(r) + '"'),
        (l = { hash: {}, data: e }),
        (r = a.elAttributes),
        (n = r ? r.call(t, t.attributes, l) : f.call(t, 'elAttributes', t.attributes, l)),
        (n || 0 === n) && (i += n),
        (i += '>'),
        (n = a.seoMetadata)
          ? (n = n.call(t, { hash: {}, data: e }))
          : ((n = t.seoMetadata), (n = typeof n === d ? n.apply(t) : n)),
        (n || 0 === n) && (i += n),
        (n = a.kalturaLinks)
          ? (n = n.call(t, { hash: {}, data: e }))
          : ((n = t.kalturaLinks), (n = typeof n === d ? n.apply(t) : n)),
        (n || 0 === n) && (i += n),
        (i += '</div>\n')
      );
    }
    function i(t, e) {
      var r,
        n = '';
      return (
        (n += '&entry_id='),
        (r = a.entryId)
          ? (r = r.call(t, { hash: {}, data: e }))
          : ((r = t.entryId), (r = typeof r === d ? r.apply(t) : r)),
        (n += u(r))
      );
    }
    function s(t, e) {
      var r,
        n = '';
      return (
        (n += '&cache_st='),
        (r = a.cacheSt)
          ? (r = r.call(t, { hash: {}, data: e }))
          : ((r = t.cacheSt), (r = typeof r === d ? r.apply(t) : r)),
        (n += u(r))
      );
    }
    (this.compilerInfo = [2, '>= 1.0.0-rc.3']), (a = a || t.helpers), (n = n || {});
    var o,
      p,
      h,
      c = '',
      d = 'function',
      u = this.escapeExpression,
      f = a.helperMissing,
      y = this;
    return (
      (o = a['if'].call(e, e.includeSeoMetadata, { hash: {}, inverse: y.noop, fn: y.program(1, l, n), data: n })),
      (o || 0 === o) && (c += o),
      (c += '<script src="'),
      (o = a.scriptUrl)
        ? (o = o.call(e, { hash: {}, data: n }))
        : ((o = e.scriptUrl), (o = typeof o === d ? o.apply(e) : o)),
      (c += u(o) + '?autoembed=true'),
      (o = a['if'].call(e, e.entryId, { hash: {}, inverse: y.noop, fn: y.program(3, i, n), data: n })),
      (o || 0 === o) && (c += o),
      (c += '&playerId='),
      (o = a.playerId)
        ? (o = o.call(e, { hash: {}, data: n }))
        : ((o = e.playerId), (o = typeof o === d ? o.apply(e) : o)),
      (c += u(o)),
      (o = a['if'].call(e, e.cacheSt, { hash: {}, inverse: y.noop, fn: y.program(5, s, n), data: n })),
      (o || 0 === o) && (c += o),
      (c += '&width='),
      (o = a.width) ? (o = o.call(e, { hash: {}, data: n })) : ((o = e.width), (o = typeof o === d ? o.apply(e) : o)),
      (c += u(o) + '&height='),
      (o = a.height) ? (o = o.call(e, { hash: {}, data: n })) : ((o = e.height), (o = typeof o === d ? o.apply(e) : o)),
      (c += u(o)),
      (h = { hash: {}, data: n }),
      (o = a.flashVarsUrl),
      (p = o ? o.call(e, e.flashVars, h) : f.call(e, 'flashVarsUrl', e.flashVars, h)),
      (p || 0 === p) && (c += p),
      (c += '"></script>')
    );
  })),
  (this.Handlebars.templates['templates/dynamic.hbs'] = Handlebars.template(function (t, e, a, r, n) {
    (this.compilerInfo = [2, '>= 1.0.0-rc.3']), (a = a || t.helpers), (n = n || {});
    var l,
      i,
      s,
      o = '',
      p = 'function',
      h = this.escapeExpression,
      c = a.helperMissing;
    return (
      (o += '<script src="'),
      (l = a.scriptUrl)
        ? (l = l.call(e, { hash: {}, data: n }))
        : ((l = e.scriptUrl), (l = typeof l === p ? l.apply(e) : l)),
      (o += h(l) + '"></script>\n<div id="'),
      (l = a.playerId)
        ? (l = l.call(e, { hash: {}, data: n }))
        : ((l = e.playerId), (l = typeof l === p ? l.apply(e) : l)),
      (o += h(l) + '"'),
      (s = { hash: {}, data: n }),
      (l = a.elAttributes),
      (i = l ? l.call(e, e.attributes, s) : c.call(e, 'elAttributes', e.attributes, s)),
      (i || 0 === i) && (o += i),
      (o += '>'),
      (i = a.seoMetadata)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.seoMetadata), (i = typeof i === p ? i.apply(e) : i)),
      (i || 0 === i) && (o += i),
      (i = a.kalturaLinks)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.kalturaLinks), (i = typeof i === p ? i.apply(e) : i)),
      (i || 0 === i) && (o += i),
      (o += '</div>\n<script>\nkWidget.'),
      (i = a.embedMethod)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.embedMethod), (i = typeof i === p ? i.apply(e) : i)),
      (o += h(i) + '('),
      (i = a.kWidgetObject)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.kWidgetObject), (i = typeof i === p ? i.apply(e) : i)),
      (i || 0 === i) && (o += i),
      (o += ');\n</script>')
    );
  })),
  (this.Handlebars.templates['templates/iframe.hbs'] = Handlebars.template(function (t, e, a, r, n) {
    function l(t, e) {
      var r,
        n = '';
      return (
        (n += '&entry_id='),
        (r = a.entryId)
          ? (r = r.call(t, { hash: {}, data: e }))
          : ((r = t.entryId), (r = typeof r === h ? r.apply(t) : r)),
        (n += c(r))
      );
    }
    (this.compilerInfo = [2, '>= 1.0.0-rc.3']), (a = a || t.helpers), (n = n || {});
    var i,
      s,
      o,
      p = '',
      h = 'function',
      c = this.escapeExpression,
      d = this,
      u = a.helperMissing;
    return (
      (p += '<iframe id="'),
      (i = a.playerId)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.playerId), (i = typeof i === h ? i.apply(e) : i)),
      (p += c(i) + '" src="'),
      (i = a.protocol)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.protocol), (i = typeof i === h ? i.apply(e) : i)),
      (p += c(i) + '://'),
      (i = a.host) ? (i = i.call(e, { hash: {}, data: n })) : ((i = e.host), (i = typeof i === h ? i.apply(e) : i)),
      (p += c(i) + '/p/'),
      (i = a.partnerId)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.partnerId), (i = typeof i === h ? i.apply(e) : i)),
      (p += c(i) + '/sp/'),
      (i = a.partnerId)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.partnerId), (i = typeof i === h ? i.apply(e) : i)),
      (p += c(i) + '00/embedIframeJs/uiconf_id/'),
      (i = a.uiConfId)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.uiConfId), (i = typeof i === h ? i.apply(e) : i)),
      (p += c(i) + '/partner_id/'),
      (i = a.partnerId)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.partnerId), (i = typeof i === h ? i.apply(e) : i)),
      (p += c(i) + '?iframeembed=true&playerId='),
      (i = a.playerId)
        ? (i = i.call(e, { hash: {}, data: n }))
        : ((i = e.playerId), (i = typeof i === h ? i.apply(e) : i)),
      (p += c(i)),
      (i = a['if'].call(e, e.entryId, { hash: {}, inverse: d.noop, fn: d.program(1, l, n), data: n })),
      (i || 0 === i) && (p += i),
      (o = { hash: {}, data: n }),
      (i = a.flashVarsUrl),
      (s = i ? i.call(e, e.flashVars, o) : u.call(e, 'flashVarsUrl', e.flashVars, o)),
      (s || 0 === s) && (p += s),
      (p += '" width="'),
      (s = a.width) ? (s = s.call(e, { hash: {}, data: n })) : ((s = e.width), (s = typeof s === h ? s.apply(e) : s)),
      (p += c(s) + '" height="'),
      (s = a.height) ? (s = s.call(e, { hash: {}, data: n })) : ((s = e.height), (s = typeof s === h ? s.apply(e) : s)),
      (p +=
        c(s) +
        '" allowfullscreen webkitallowfullscreen mozAllowFullScreen allow="autoplay *; fullscreen *; encrypted-media *" frameborder="0"'),
      (o = { hash: {}, data: n }),
      (i = a.elAttributes),
      (s = i ? i.call(e, e.attributes, o) : u.call(e, 'elAttributes', e.attributes, o)),
      (s || 0 === s) && (p += s),
      (p += '>'),
      (s = a.seoMetadata)
        ? (s = s.call(e, { hash: {}, data: n }))
        : ((s = e.seoMetadata), (s = typeof s === h ? s.apply(e) : s)),
      (s || 0 === s) && (p += s),
      (s = a.kalturaLinks)
        ? (s = s.call(e, { hash: {}, data: n }))
        : ((s = e.kalturaLinks), (s = typeof s === h ? s.apply(e) : s)),
      (s || 0 === s) && (p += s),
      (p += '</iframe>')
    );
  })),
  (this.Handlebars.templates['templates/kaltura_links.hbs'] = Handlebars.template(function (t, e, a, r, n) {
    return (
      (this.compilerInfo = [2, '>= 1.0.0-rc.3']),
      (a = a || t.helpers),
      (n = n || {}),
      '<a href="http://corp.kaltura.com/products/video-platform-features">Video Platform</a>\n<a href="http://corp.kaltura.com/Products/Features/Video-Management">Video Management</a> \n<a href="http://corp.kaltura.com/Video-Solutions">Video Solutions</a>\n<a href="http://corp.kaltura.com/Products/Features/Video-Player">Video Player</a>'
    );
  })),
  (this.Handlebars.templates['templates/legacy.hbs'] = Handlebars.template(function (t, e, a, r, n) {
    function l(t, e) {
      var r,
        n = '';
      return (
        (n += '<script src="'),
        (r = a.scriptUrl)
          ? (r = r.call(t, { hash: {}, data: e }))
          : ((r = t.scriptUrl), (r = typeof r === c ? r.apply(t) : r)),
        (n += d(r) + '"></script>\n')
      );
    }
    function i(t, e) {
      var r,
        n,
        l = '';
      return (
        (l +=
          '\n	<a rel="media:thumbnail" href="' +
          d(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.thumbnailUrl), typeof r === c ? r.apply(t) : r)) +
          '"></a>\n	<span property="dc:description" content="' +
          d(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.description), typeof r === c ? r.apply(t) : r)) +
          '"></span>\n	<span property="media:title" content="' +
          d(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.name), typeof r === c ? r.apply(t) : r)) +
          '"></span>\n    <span property="media:uploadDate" content="' +
          d(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.uploadDate), typeof r === c ? r.apply(t) : r)) +
          '"></span>\n	<span property="media:width" content="'),
        (n = a.width) ? (n = n.call(t, { hash: {}, data: e })) : ((n = t.width), (n = typeof n === c ? n.apply(t) : n)),
        (l += d(n) + '"></span>\n	<span property="media:height" content="'),
        (n = a.height)
          ? (n = n.call(t, { hash: {}, data: e }))
          : ((n = t.height), (n = typeof n === c ? n.apply(t) : n)),
        (l += d(n) + '"></span>\n	<span property="media:type" content="application/x-shockwave-flash"></span>	\n	')
      );
    }
    (this.compilerInfo = [2, '>= 1.0.0-rc.3']), (a = a || t.helpers), (n = n || {});
    var s,
      o,
      p,
      h = '',
      c = 'function',
      d = this.escapeExpression,
      u = this,
      f = a.helperMissing;
    return (
      (s = a['if'].call(e, e.includeHtml5Library, { hash: {}, inverse: u.noop, fn: u.program(1, l, n), data: n })),
      (s || 0 === s) && (h += s),
      (h += '<object id="'),
      (s = a.playerId)
        ? (s = s.call(e, { hash: {}, data: n }))
        : ((s = e.playerId), (s = typeof s === c ? s.apply(e) : s)),
      (h += d(s) + '" name="'),
      (s = a.playerId)
        ? (s = s.call(e, { hash: {}, data: n }))
        : ((s = e.playerId), (s = typeof s === c ? s.apply(e) : s)),
      (h +=
        d(s) +
        '" type="application/x-shockwave-flash" allowFullScreen="true" allowNetworking="all" allowScriptAccess="always" height="'),
      (s = a.height) ? (s = s.call(e, { hash: {}, data: n })) : ((s = e.height), (s = typeof s === c ? s.apply(e) : s)),
      (h += d(s) + '" width="'),
      (s = a.width) ? (s = s.call(e, { hash: {}, data: n })) : ((s = e.width), (s = typeof s === c ? s.apply(e) : s)),
      (h += d(s) + '" bgcolor="#000000"'),
      (p = { hash: {}, data: n }),
      (s = a.elAttributes),
      (o = s ? s.call(e, e.attributes, p) : f.call(e, 'elAttributes', e.attributes, p)),
      (o || 0 === o) && (h += o),
      (h += ' data="'),
      (o = a.swfUrl) ? (o = o.call(e, { hash: {}, data: n })) : ((o = e.swfUrl), (o = typeof o === c ? o.apply(e) : o)),
      (h +=
        d(o) +
        '">\n	<param name="allowFullScreen" value="true" />\n	<param name="allowNetworking" value="all" />\n	<param name="allowScriptAccess" value="always" />\n	<param name="bgcolor" value="#000000" />\n	<param name="flashVars" value="'),
      (p = { hash: {}, data: n }),
      (s = a.flashVarsString),
      (o = s ? s.call(e, e.flashVars, p) : f.call(e, 'flashVarsString', e.flashVars, p)),
      (o || 0 === o) && (h += o),
      (h += '" />\n	<param name="movie" value="'),
      (o = a.swfUrl) ? (o = o.call(e, { hash: {}, data: n })) : ((o = e.swfUrl), (o = typeof o === c ? o.apply(e) : o)),
      (h += d(o) + '" />\n	'),
      (o = a['if'].call(e, e.includeSeoMetadata, { hash: {}, inverse: u.noop, fn: u.program(3, i, n), data: n })),
      (o || 0 === o) && (h += o),
      (o = a.kalturaLinks)
        ? (o = o.call(e, { hash: {}, data: n }))
        : ((o = e.kalturaLinks), (o = typeof o === c ? o.apply(e) : o)),
      (o || 0 === o) && (h += o),
      (h += '\n</object>')
    );
  })),
  (this.Handlebars.templates['templates/seo_metadata.hbs'] = Handlebars.template(function (t, e, a, r, n) {
    function l(t, e) {
      var r,
        n,
        l = '';
      return (
        (l +=
          '\n<span itemprop="name" content="' +
          o(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.name), typeof r === s ? r.apply(t) : r)) +
          '"></span>\n<span itemprop="description" content="' +
          o(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.description), typeof r === s ? r.apply(t) : r)) +
          '"></span>\n<span itemprop="duration" content="' +
          o(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.duration), typeof r === s ? r.apply(t) : r)) +
          '"></span>\n<span itemprop="thumbnailUrl" content="' +
          o(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.thumbnailUrl), typeof r === s ? r.apply(t) : r)) +
          '"></span>\n<span itemprop="uploadDate" content="' +
          o(((r = t.entryMeta), (r = null == r || r === !1 ? r : r.uploadDate), typeof r === s ? r.apply(t) : r)) +
          '"></span>\n<span itemprop="width" content="'),
        (n = a.width) ? (n = n.call(t, { hash: {}, data: e })) : ((n = t.width), (n = typeof n === s ? n.apply(t) : n)),
        (l += o(n) + '"></span>\n<span itemprop="height" content="'),
        (n = a.height)
          ? (n = n.call(t, { hash: {}, data: e }))
          : ((n = t.height), (n = typeof n === s ? n.apply(t) : n)),
        (l += o(n) + '"></span>\n')
      );
    }
    (this.compilerInfo = [2, '>= 1.0.0-rc.3']), (a = a || t.helpers), (n = n || {});
    var i,
      s = 'function',
      o = this.escapeExpression,
      p = this;
    return (
      (i = a['if'].call(e, e.includeSeoMetadata, { hash: {}, inverse: p.noop, fn: p.program(1, l, n), data: n })),
      i || 0 === i ? i : ''
    );
  })),
  Array.prototype.indexOf ||
    (Array.prototype.indexOf = function (t) {
      'use strict';
      if (null == this) throw new TypeError();
      var e = Object(this),
        a = e.length >>> 0;
      if (0 === a) return -1;
      var r = 0;
      if (
        (arguments.length > 1 &&
          ((r = Number(arguments[1])),
          r !== r ? (r = 0) : 0 !== r && 1 / 0 !== r && r !== -1 / 0 && (r = (r > 0 || -1) * Math.floor(Math.abs(r)))),
        r >= a)
      )
        return -1;
      for (var n = r >= 0 ? r : Math.max(a - Math.abs(r), 0); a > n; n++) if (n in e && e[n] === t) return n;
      return -1;
    }),
  Object.keys ||
    (Object.keys = (function () {
      var t = Object.prototype.hasOwnProperty,
        e = !{ toString: null }.propertyIsEnumerable('toString'),
        a = [
          'toString',
          'toLocaleString',
          'valueOf',
          'hasOwnProperty',
          'isPrototypeOf',
          'propertyIsEnumerable',
          'constructor',
        ],
        r = a.length;
      return function (n) {
        if (('object' != typeof n && 'function' != typeof n) || null === n)
          throw new TypeError('Object.keys called on non-object');
        var l = [];
        for (var i in n) t.call(n, i) && l.push(i);
        if (e) for (var s = 0; r > s; s++) t.call(n, a[s]) && l.push(a[s]);
        return l;
      };
    })()),
  (function (t, e) {
    var a = function (t) {
      this.init(t);
    };
    (a.prototype = {
      types: ['auto', 'dynamic', 'thumb', 'iframe', 'legacy'],
      required: ['widgetId', 'partnerId', 'uiConfId'],
      defaults: {
        embedType: 'auto',
        playerId: 'kaltura_player',
        protocol: 'http',
        host: 'www.kaltura.com',
        securedHost: 'www.kaltura.com',
        widgetId: null,
        partnerId: null,
        cacheSt: null,
        uiConfId: null,
        entryId: null,
        entryMeta: {},
        width: 400,
        height: 330,
        attributes: {},
        flashVars: {},
        includeKalturaLinks: !0,
        includeSeoMetadata: !1,
        includeHtml5Library: !0,
      },
      extend: function (t, e) {
        for (var a in e) e.hasOwnProperty(a) && !t.hasOwnProperty(a) && (t[a] = e[a]);
        return t;
      },
      isNull: function (t) {
        return null === t
          ? !0
          : t.length && t.length > 0
          ? !1
          : t.length && 0 === t.length
          ? !0
          : 'object' == typeof t
          ? Object.keys(t).length > 0
            ? !1
            : !0
          : !t;
      },
      init: function (t) {
        if (((t = t || {}), this.defaults, typeof Handlebars === e))
          throw 'Handlebars is not defined, please include Handlebars.js before this script';
        return (
          'object' == typeof t && (this.options = this.extend(t, this.defaults)),
          !this.config('widgetId') &&
            this.config('partnerId') &&
            this.config('widgetId', '_' + this.config('partnerId')),
          this
        );
      },
      config: function (t, a) {
        return a === e && 'string' == typeof t && this.options.hasOwnProperty(t)
          ? this.options[t]
          : t === e && a === e
          ? this.options
          : ('string' == typeof t && a !== e && (this.options[t] = a), null);
      },
      checkRequiredParams: function (t) {
        var e = this.required.length,
          a = 0;
        for (a; e > a; a++)
          if (this.isNull(t[this.required[a]])) throw 'Missing required parameter: ' + this.required[a];
      },
      checkValidType: function (t) {
        var e = -1 !== this.types.indexOf(t) ? !0 : !1;
        if (!e) throw 'Embed type: ' + t + ' is not valid. Available types: ' + this.types.join(',');
      },
      getTemplate: function (t) {
        t = 'thumb' == t ? 'dynamic' : t;
        var e = 'templates/' + t + '.hbs';
        return t && Handlebars.templates && Handlebars.templates[e] ? Handlebars.templates[e] : null;
      },
      isKWidgetEmbed: function (t) {
        return 'dynamic' == t || 'thumb' == t ? !0 : !1;
      },
      getHost: function (t) {
        return 'http' === t.protocol ? t.host : t.securedHost;
      },
      getScriptUrl: function (t) {
        return (
          t.protocol +
          '://' +
          this.getHost(t) +
          '/p/' +
          t.partnerId +
          '/sp/' +
          t.partnerId +
          '00/embedIframeJs/uiconf_id/' +
          t.uiConfId +
          '/partner_id/' +
          t.partnerId
        );
      },
      getSwfUrl: function (t) {
        var e = t.cacheSt ? '/cache_st/' + t.cacheSt : '',
          a = t.entryId ? '/entry_id/' + t.entryId : '';
        return (
          t.protocol +
          '://' +
          this.getHost(t) +
          '/index.php/kwidget' +
          e +
          '/wid/' +
          t.widgetId +
          '/uiconf_id/' +
          t.uiConfId +
          a
        );
      },
      getAttributes: function (t) {
        var e = {};
        return (
          (this.isKWidgetEmbed(t.embedType) || t.includeSeoMetadata) &&
            (e.style = 'width: ' + t.width + 'px; height: ' + t.height + 'px;'),
          t.includeSeoMetadata &&
            ('legacy' == t.embedType
              ? ((e['xmlns:dc'] = 'http://purl.org/dc/terms/'),
                (e['xmlns:media'] = 'http://search.yahoo.com/searchmonkey/media/'),
                (e.rel = 'media:video'),
                (e.resource = this.getSwfUrl(t)))
              : ((e.itemprop = 'video'), (e['itemscope itemtype'] = 'http://schema.org/VideoObject'))),
          e
        );
      },
      getEmbedObject: function (t) {
        var e = { targetId: t.playerId, wid: t.widgetId, uiconf_id: t.uiConfId, flashvars: t.flashVars };
        return t.cacheSt && (e.cache_st = t.cacheSt), t.entryId && (e.entry_id = t.entryId), JSON.stringify(e, null, 2);
      },
      getCode: function (t) {
        var a = t === e ? {} : this.extend({}, t);
        (a = this.extend(a, this.config())),
          !a.widgetId && a.partnerId && (a.widgetId = '_' + a.partnerId),
          this.checkRequiredParams(a),
          this.checkValidType(a.embedType);
        var r = this.getTemplate(a.embedType);
        if (!r) throw 'Template: ' + a.embedType + ' is not defined as Handlebars template';
        var n = { host: this.getHost(a), scriptUrl: this.getScriptUrl(a), attributes: this.getAttributes(a) };
        return (
          'legacy' === a.embedType && (n.swfUrl = this.getSwfUrl(a)),
          this.isKWidgetEmbed(a.embedType) &&
            ((n.embedMethod = 'dynamic' == a.embedType ? 'embed' : 'thumbEmbed'),
            (n.kWidgetObject = this.getEmbedObject(a))),
          (n = this.extend(n, a)),
          r(n)
        );
      },
    }),
      (t.kEmbedCodeGenerator = a);
  })(this);
